import React from 'react';
import { NotFound } from '@shootsta/common-react';
import { getIdentityOriginUrl } from '../../../../utils';

export default function LostPage() {
  return <NotFound homeUrl={getIdentityOriginUrl()} />;
}
